import { Profile } from "../../../lib/profiles/types";
import { MainLayout } from "../../../commons/components/layouts";
import { publicMenu } from "./publicMenu";

export const publicProfile: Profile = {
  name: "public",
  component: MainLayout,
  menu: publicMenu,
};
